import React, {Component} from 'react';

export default class ContentListItem extends Component {
    constructor(props){
        super(props);
    }

    render() {    
        var item=this.props.item;
        
        return(
            <p>
                {item.text}
            </p>
        )
    }
}
